import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Input, Table } from "reactstrap";
import { ButtonWithLoader } from "../../core";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import middlewareConstants from "../../shared/middleware-constant";
import { middlewareService } from "../../shared/service";
import { dpValidation, setConsentApi } from "../services/waitlist-service";
// import { Mixpanel } from "./MixPanel";
import { utils } from "../../core/helpers/utils";
import { initBranch, trackEvent } from "../../core/helpers/branchio";

export default function PaymentDetailsFirst(props) {
  const [dematNo, setDematNo] = useState(props.demat);
  const [enable, setEnable] = useState(true);
  const [product, setProduct] = useState(props?.product);
  const [paymentFlow, setPaymentFlow] = useState()

  const exchange = props?.rfqExchangeType ? props.rfqExchangeType.toLowerCase() : "";

  const history = useHistory();

  const onPaymentChange = (val) => {
    setPaymentFlow(val)
  }

  const confirmPayment = () => {
    { process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent(window.location.pathname + window.location.hash,"Bidd_Investment Over_Confirm");
    }
    initBranch().then(() => {
      trackEvent(`Bidd_Investment Over_Confirm`);
    }).catch(error => console.error('Error initializing Branch:', error))
    // Mixpanel.track("cl_confirm_deal",
    //   {
    //     "Bond Name": props.oppName,
    //     "Email id": props.userEmail
    //   }
    // );
    setEnable(false);
    let dpId = dematNo.substr(0, 8);
    dpValidation(dpId, { "X-product": `orobonds:${product}` }).then(
      (result) => {
        const dpResp = utils.parsePayload(result);
        if (dpResp && dpResp.success) {
          let headers = {
            "X-product": `orobonds:${props.product}`
          };
          let payload = {
            type: "obTransaction",
            consent: true,
          };
          setConsentApi(payload, headers)
            .then(result => {
              const response = utils.parsePayload(result);
              if (response && response.successs) {
                props.goToPayment(dematNo, paymentFlow);
              }
            })
        } else {
          toast.error("Invalid demat number");
        }
      }
    )
  };

  useEffect(() => {
    if (props?.userInRfqCug && props?.ucc?.[exchange]?.uccCreated) {
      setPaymentFlow(exchange);
    }
  }, [])


  return (
    <div className="modal-div-main payment-main">
      <p className="title font-weight-semi-bold mb-3">Investment Overview</p>
      <Table bordered>
        <tr>
          <td>Opportunity name</td>
          <td>{props.productname}</td>
        </tr>
        <tr>
          <td>Issuer name</td>
          <td>{props.oppName}</td>
        </tr>
        <tr>
          <td>Units</td>
          <td>{props?.units}</td>
        </tr>
        {props?.ytm && (<tr>
          <td>YTM</td>
          <td>{props?.ytm ? props?.ytm + '% p.a.' : null}</td>
        </tr>)}
        {
          props?.investmentAmount.exchangeStampDuty > 0 ?
            <>
              <tr>
                <td>Total Amount (w/o Stamp Duty)</td>
                <td>{props?.benefit ? (parseFloat(props?.benefit + props?.investmentAmount?.userAmount)).oroNumber(2, true) : props?.referralBenefit ?
                  (parseFloat(props?.referralBenefit + props?.investmentAmount?.userAmount)).oroNumber(2, true) : (props?.investmentAmount?.userAmount).oroNumber(2, true)}</td>
              </tr>
              <tr>
                <td>Stamp Duty</td>
                <td>
                  {(props.investmentAmount.exchangeStampDuty).oroNumber(2, true)}
                </td>
              </tr>
            </>
            :
            <tr>
              <td>
                Total Amount
              </td>
              <td>{props?.benefit ? (parseFloat(props?.benefit + props?.investmentAmount?.userAmount)).oroNumber(2, true) : props?.referralBenefit ?
                (parseFloat(props?.referralBenefit + props?.investmentAmount?.userAmount)).oroNumber(2, true) : (props?.investmentAmount?.userAmount).oroNumber(2, true)}</td>
            </tr>
        }
        
        {(props?.benefit || props.referralBenefit) ? <>
          <tr>
            <td className="text-primary">🎁 Offer Benefit</td>
            <td>
              {(props?.benefit).oroNumber(2, true) || (props?.referralBenefit).oroNumber(2, true)}{" "}
            </td>
          </tr>

          {
            props?.investmentAmount.exchangeStampDuty > 0 ?
              <tr>
                <td>
                  Total Payable Amount (with Stamp Duty)
                </td>
                <td>{parseFloat(props.investmentAmount.withStampDutyUserAmount).oroNumber(2, true)}</td>
              </tr>
              :
              <tr>
                <td>Total Payable Amount</td>
                <td>{props.amount}</td>
              </tr>
          }
        </>
          :
          props?.investmentAmount.exchangeStampDuty > 0 ?
            <tr>
              <td>
                Total Payable Amount (with Stamp Duty)
              </td>
              <td>{parseFloat(props.investmentAmount.withStampDutyUserAmount).oroNumber(2, true)}</td>
            </tr>
            :
            <tr>
              <td>Total Payable Amount</td>
              <td>{props.amount}</td>
            </tr>
        }
        
        <tr>
          <td>Demat Account Number</td>
          <td>
            <div className="p-0 demat-flex">
              <Input
                id="demat"
                type="text"
                pattern="[0-9a-zA-Z]*"
                inputMode="numeric"
                className="text-center"
                readOnly={true}
                value={dematNo ? dematNo : ""}
                onChange={(e) => {
                  setDematNo(e.target.value);
                }}
                placeholder="Enter demat account number"
              />
            </div>
          </td>
        </tr>
      </Table>
      {(props?.userInRfqCug && props?.ucc?.[exchange].uccCreated) && <div>
        <p className="footer">
          <input type="checkbox"
            defaultChecked={props?.checked}
            onChange={() => props?.handleChecked()}
          />&nbsp;
          I accept to &nbsp;
          <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms, Conditions and Disclaimer</b></a>
        </p>
      </div>}
      {(!props?.userInRfqCug || !props?.ucc?.[exchange].uccCreated) && <p className="footer">
        <input type="checkbox"
          defaultChecked={props?.checked}
          onChange={() => props?.handleChecked()}
        />&nbsp;
        I accept to &nbsp;
        <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms, Conditions and Disclaimer</b></a>
      </p>}
      <ButtonWithLoader
        color="secondary"
        onClick={confirmPayment}
        text="Confirm"
        isLoading={props.loader}
        disabled={!props.checked || !props.isTxnAllowed}
      />
      {props?.userInRfqCug ?
        <>
          <p className="text-secondary font-size-14 mt-4">Are you sure you want to place an order?</p>
          <p className="font-size-12"> The order will go to {exchange.toUpperCase()} and you will be obliged to make the payment within 24hrs.
            In case of non payment penalties will apply as seen in terms and conditions.</p>
        </>
        : null
      }
      {!props.isTxnAllowed &&
        <>
          <p className="mt-3 mb-0 font-small text-primary">This bond has completely sold out!</p>
          <p className="font-small text-primary">Please contact connect@biddeasy.com for more details.</p>
        </>
      }
    </div>
  );
}